import { FeeStatus } from 'api-paths-cas';

export type InputChangeEvent = {
  currentTarget: { value: string };
  target: {
    value: string;
  };
};

export const feeStatusLabels: Record<FeeStatus, string> = {
  [FeeStatus.Home]: 'Home',
  [FeeStatus.Overseas]: 'Overseas',
  [FeeStatus.NotSure]: 'Not Sure',
};
